// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/banner/banner.scss
// module id = 137
// module chunks = 0